var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68448 2.44901C6.89123 2.24226 7.22643 2.24226 7.43318 2.44901L16.9626 11.9784C17.1693 12.1852 17.1693 12.5204 16.9626 12.7271L7.43318 22.2565C7.22643 22.4633 6.89123 22.4633 6.68448 22.2565C6.47773 22.0498 6.47773 21.7146 6.68448 21.5078L15.8395 12.3528L6.68448 3.19771C6.47773 2.99096 6.47773 2.65575 6.68448 2.44901Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.26a4a4b6a1aae56a0d98d3df753d2532.svg";
export { ForwardRef as ReactComponent };